var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 91,
    viewBox: "0 0 75 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6136 31.0219C72.0792 31.4314 62.6443 36.6821 62.6443 48.3574C62.6443 61.8618 74.6499 66.6393 75.0092 66.7576C74.9539 67.0488 73.102 73.3005 68.6794 79.6705C64.7359 85.2761 60.6173 90.8726 54.352 90.8726C48.0866 90.8726 46.4742 87.2781 39.2414 87.2781C32.1929 87.2781 29.6867 90.9909 23.9558 90.9909C18.2248 90.9909 14.226 85.8039 9.62838 79.4339C4.30283 71.9537 0 60.333 0 49.3038C0 31.6134 11.6462 22.2313 23.1081 22.2313C29.1984 22.2313 34.2752 26.1807 38.0989 26.1807C41.7383 26.1807 47.414 21.9947 54.3428 21.9947C56.9687 21.9947 66.4036 22.2313 72.6136 31.0219ZM51.0534 14.5054C53.9189 11.1475 55.9459 6.4883 55.9459 1.8291C55.9459 1.183 55.8907 0.5278 55.7709 0C51.1087 0.1729 45.562 3.0667 42.2174 6.8978C39.5915 9.8462 37.1407 14.5054 37.1407 19.2283C37.1407 19.9381 37.2604 20.6479 37.3157 20.8754C37.6106 20.93 38.0897 20.9937 38.5688 20.9937C42.7518 20.9937 48.0129 18.2273 51.0534 14.5054Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.9d1b157621290ace9885ccbea3e5281a.svg";
export { ForwardRef as ReactComponent };